module.exports = __webpack_public_path__ + "img/Avatar-33.8eca90a2.svg";